import Stats from './stats-redux';

export default Stats;